import { render } from "./HomesHealthy.vue?vue&type=template&id=f2eda9de"
import script from "./HomesHealthy.vue?vue&type=script&lang=js"
export * from "./HomesHealthy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rnedkov/Documents/GitHub/cleaner-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__